<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="title">ช่องทางติดต่อรายการ</h5>
    </template>
    <template v-slot:section-body>
      <form>
        <div class="row">
          <div class="col-md-4">
            <FormGroup :errorMessage="getErrorMessage('facebook')">
              <h5 class="name">Facebook</h5>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">facebook.com/</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': getErrorMessage('facebook')}"
                  :value="currentProgram.facebook"
                  @blur="$store.dispatch('setCurrentProgram', { facebook: $event.target.value })"/>
              </div>
            </FormGroup>
            <FormGroup :errorMessage="getErrorMessage('youtube')">
              <h5 class="name">Youtube</h5>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">youtube.com/</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': getErrorMessage('youtube')}"
                  :value="currentProgram.youtube"
                  @blur="$store.dispatch('setCurrentProgram', { youtube: $event.target.value })"/>
              </div>
            </FormGroup>
            <FormGroup :errorMessage="getErrorMessage('mail')">
              <h5 class="name">อีเมล</h5>
              <input
                class="form-control"
                :class="{'is-invalid': getErrorMessage('mail')}"
                :value="currentProgram.mail"
                @blur="$store.dispatch('setCurrentProgram', { mail: $event.target.value })"/>
                <div
                  class="invalid-feedback"
                  v-if="getErrorMessage('mail')">{{getErrorMessage('mail')}}</div>
            </FormGroup>
          </div>
          <div class="col-md-4">
            <FormGroup :errorMessage="getErrorMessage('twitter')">
              <h5 class="name">Twitter</h5>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">twitter.com/</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': getErrorMessage('twitter')}"
                  :value="currentProgram.twitter"
                  @blur="$store.dispatch('setCurrentProgram', { twitter: $event.target.value })"/>
              </div>
            </FormGroup>
            <FormGroup :errorMessage="getErrorMessage('instagram')">
              <h5 class="name">Instagram</h5>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">instagram.com/</span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  :class="{'is-invalid': getErrorMessage('instagram')}"
                  :value="currentProgram.instagram"
                  @blur="$store.dispatch('setCurrentProgram', { instagram: $event.target.value })"/>
              </div>
            </FormGroup>
            <FormGroup :errorMessage="getErrorMessage('website')">
              <h5 class="name">เว็บไซต์</h5>
              <input
                type="text"
                class="form-control"
                :value="currentProgram.website"
                @blur="$store.dispatch('setCurrentProgram', { website: $event.target.value })"/>
            </FormGroup>
          </div>
        </div>
      </form>
    </template>
  </Section>
</template>

<script>
/* eslint no-useless-escape: ["off"] */
import _ from 'lodash';
import { mapState } from 'vuex';
import FormGroup from '@/components/FormGroup.vue';
import Section from '@/components/Section.vue';

export default {
  components: {
    FormGroup,
    Section,
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
      saveProgramState: (state) => state.programItem.saveProgramState,
    }),
    baseURL() {
      return process.env.VUE_APP_BASEURL || window.location.origin;
    },
  },
  methods: {
    getErrorMessage(fieldName) {
      return _.get(this.saveProgramState.error, `${fieldName}`, null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
@import './src/assets/scss/themes/components/section-container.scss';

</style>
